import { StructuredJsonFieldDef } from '../../shared/design-system/structured-json-form.model';

export const GROWTH_AGENT_INSTALL_LIFECYCLE_STATUSES = ['Available', 'Installed', 'Disabled'] as const;

export const GROWTH_AGENT_RECOMMENDATION_TYPES = [
  'CampaignBrief',
  'SegmentChange',
  'ContentIdea',
  'RevenueAction',
  'RiskWarning',
  'StrategyChange',
  'OptimizerSuggestion'
] as const;

export const growthAgentPermissionManifestFields: StructuredJsonFieldDef[] = [
  {
    key: 'allowRun',
    type: 'boolean',
    labelKey: 'growth.agentMarketplace.permissions.fields.allowRun'
  }
];

export function parseAllowedRecommendationTypes(payloadJson: string): string[] {
  try {
    const parsed = JSON.parse(payloadJson || '{}') as { allowedRecommendationTypes?: unknown };
    if (!Array.isArray(parsed.allowedRecommendationTypes)) {
      return [...GROWTH_AGENT_RECOMMENDATION_TYPES];
    }
    return parsed.allowedRecommendationTypes.filter((item): item is string => typeof item === 'string');
  } catch {
    return [...GROWTH_AGENT_RECOMMENDATION_TYPES];
  }
}

export function mergePermissionManifestJson(allowRunPayloadJson: string, allowedRecommendationTypes: string[]): string {
  let base: Record<string, unknown> = {};
  try {
    const parsed = JSON.parse(allowRunPayloadJson || '{}') as Record<string, unknown>;
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      base = parsed;
    }
  } catch {
    // use empty base
  }
  return JSON.stringify({
    ...base,
    allowRun: base['allowRun'] === true || base['allowRun'] === 'true',
    allowedRecommendationTypes
  });
}
